// CarrinhoContext.js

import React, { createContext, useState, useEffect } from "react";

const CarrinhoContext = createContext();

const CarrinhoProvider = ({ children }) => {
  const [carrinho, setCarrinho] = useState([]);

  useEffect(() => {
    const carrinhoLS = localStorage.getItem("carrinho");
    if (carrinhoLS) {
      setCarrinho(JSON.parse(carrinhoLS));
    }
  }, []);

  const adicionarItem = (item) => {
    const novoCarrinho = [...carrinho];

    // Ajuste: comparar também o formato do item
    const itemIndex = novoCarrinho.findIndex(
      (i) => i.id === item.id && i.formato === item.formato
    );

    if (itemIndex === -1) {
      novoCarrinho.push({ ...item, quantidade: 1 });
    }

    setCarrinho(novoCarrinho);
    localStorage.setItem("carrinho", JSON.stringify(novoCarrinho));
  };

  const itemJaNoCarrinho = (id, formato) => {
    // se precisar checar de modo mais completo, inclua também o formato
    return carrinho.some((item) => item.id === id && item.formato === formato);
  };

  const modificarQuantidade = (id, formato, novaQuantidade) => {
    const novoCarrinho = [...carrinho];
    const itemIndex = novoCarrinho.findIndex(
      (i) => i.id === id && i.formato === formato
    );

    if (itemIndex !== -1) {
      novoCarrinho[itemIndex].quantidade = novaQuantidade;
      setCarrinho(novoCarrinho);
      localStorage.setItem("carrinho", JSON.stringify(novoCarrinho));
    }
  };

  const removerItem = (id, formato) => {
    const novoCarrinho = carrinho.filter(
      (item) => !(item.id === id && item.formato === formato)
    );
    setCarrinho(novoCarrinho);
    localStorage.setItem("carrinho", JSON.stringify(novoCarrinho));
  };

  const limparCarrinho = () => {
    setCarrinho([]);
    localStorage.removeItem("carrinho");
  };

  const totalItens = carrinho.reduce((acc, item) => acc + item.quantidade, 0);

  const valorTotal = carrinho.reduce(
    (acc, item) => acc + item.preco * item.quantidade,
    0
  );

  return (
    <CarrinhoContext.Provider
      value={{
        carrinho,
        adicionarItem,
        itemJaNoCarrinho,
        modificarQuantidade,
        removerItem,
        limparCarrinho,
        totalItens,
        valorTotal,
      }}
    >
      {children}
    </CarrinhoContext.Provider>
  );
};

export { CarrinhoContext, CarrinhoProvider };
